
















































































import { Component, Vue, Prop, PropSync, Watch } from 'vue-property-decorator';
import { validationMixin } from 'vuelidate';
import { email, integer, minLength, numeric, required, requiredIf } from 'vuelidate/lib/validators';
import vSelect from 'vue-select';
import { AddressApi, OrgsApi, ProductsApi, SitesApi, UsersApi } from '../../api';
import SiteSuggest from '@/components/form pickers/siteSuggest.vue';
import addressSuggest from '@/components/form pickers/adrSuggest.vue';
import Toast from '@/components/display/toast.vue';

@Component({
	components: {
		addressSuggest,
		SiteSuggest,
		vSelect,
		Toast,
	},
	validations: {
		localSite: {
			name: { required },
			address: {
				fullAdr: { required },
				rawAddress: { required },
				location: { required },
			},
		},
	},
	mixins: [validationMixin],
})
export default class AddSite extends Vue {
	public existingOrg = false;
	public existingUser = false;
	public existingSite = false;
	public emailRequired = true;
	public billingRequired = true;
	public loading = false;

	@PropSync('org') public localOrg!: object;

	@PropSync('site') public localSite!: object;

	@Prop(Boolean)
	public submitOnSiteComponent? = false;

	public siteList = [];
	public $bvToast: any;
	public submitStatus: 'ERROR' | 'PENDING' | 'OK' | null = null;
	public region: any = null;
	public siteRegion: any = null;

	@Watch('site')
	public onSiteChange() {
		if (this.localOrg) {
			this.localOrg.sites.map((site: { id: any }) => this.siteList.push(site.id));
		}
	}

	public isValid(field) {
		return field && field.$dirty ? !field.$invalid : null;
	}

	public stepValidate(name: string) {
		const form = this.$v[name];
		form.$touch();
		if (!form.$invalid && this.submitOnSiteComponent) {
			this.onComplete();
		} else if (!form.$invalid) {
			this.$emit('nextTab');
		}
	}

	public async onComplete(...a: any[]) {
		this.submitStatus = 'PENDING';

		if (!this.siteList.includes(this.site.id)) {
			try {
				const lat =
					typeof this.localSite.address.rawAddress.geometry.location.lat === 'function'
						? this.localSite.address.rawAddress.geometry.location.lat()
						: this.localSite.address.rawAddress.geometry.location.lat;
				const lng =
					typeof this.localSite.address.rawAddress.geometry.location.lng === 'function'
						? this.localSite.address.rawAddress.geometry.location.lng()
						: this.localSite.address.rawAddress.geometry.location.lng;
				const promise = await new SitesApi().addSite({
					data: {
						orgId: this.localOrg.id,
						name: this.localSite.name,
						latitude: lat,
						longitude: lng,
					},
				});
				this.localOrg.activeSiteId = promise.data.data.id;
				this.localSite.id = promise.data.data.id;
				this.siteList.push(promise.data.data.id);
			} catch (e) {
				let error;
				if (e.response) {
					if (e.response.data.message) {
						error = 'Site not created ' + e.response.data.message;
					} else {
						error = 'Site not created unknown error, check response';
					}
				} else if (e.request) {
					// console.log(e.request);
					error = 'Site not created, network error';
				} else {
					// console.log("unknown Error");
					error = 'Site not created, unknown error';
				}
				// const error = e.response.data.errors.name[0];
				new Toast().makeToast(error, 'Error Adding Site', 'danger', true);
				this.submitStatus = 'ERROR';
				return;
			}
			new Toast().makeToast('Site added to org', 'Site Added', 'success');

			try {
				await new AddressApi().addAddress({
					data: {
						ownerType: 'sites',
						ownerId: this.localSite.id,
						type: 'street',
						rawAddress: this.localSite.address.rawAddress,
					},
				});
			} catch (e) {
				let error;
				if (e.response) {
					if (e.response.data.message) {
						error = 'Address not created: ' + e.response.data.message;
					} else {
						error = 'Address not created: unknown error, check response';
					}
				} else if (e.request) {
					error = 'Address not created: network Error';
				} else {
					error = 'Address not created: unknown Error';
				}
				new Toast().makeToast(error, 'Error Adding Address', 'danger', true);
				return;
			}

			this.$emit('nextTab');
		} else {
			new Toast().makeToast('Site already exists on org', 'Site Exists', 'success');
			this.localOrg.activeSiteId = this.localSite.id;
			this.$emit('nextTab');
		}
		this.submitStatus = 'OK';

		this.$emit('load');
	}
}
